export default __webpack_public_path__ + "static/media/banner-1.12e0a088.webp";